/* eslint-disable eqeqeq */
/* eslint-disable no-var */
/* eslint-disable space-before-function-paren */
/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/quotes */
import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CategoryService } from "../../category/category.service";
import { SubCategoryService } from "../sub-category.service";

@Component({
  selector: "app-add-edit-sub-category",
  templateUrl: "./add-edit-sub-category.component.html",
  styleUrls: ["./add-edit-sub-category.component.scss"],
})
export class AddEditSubCategoryComponent implements OnInit {
  subCatNameEng: string = "";
  subCatNameMar: string = "";

  selectedCategory: any = null;
  categories: any[] = [];

  subCatId = "";
  flag = "";

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private subCategoryService: SubCategoryService,
    private _snackBar: MatSnackBar,
    private categoryService: CategoryService,
    public dialogRef: MatDialogRef<AddEditSubCategoryComponent>
  ) {}

  ngOnInit() {
    console.log(this.data);
    this.getCategories();
    if (this.data[0] == "Edit") {
      this.subCatId = this.data[1]["pkSucid"];
      this.flag = "E";
      this.subCatNameEng = this.data[1]["sucNameEng"];
      this.subCatNameMar = this.data[1]["sucNameMar"];
    } else {
      this.subCatId = "";
      this.flag = "N";
    }
  }

  async getCategories() {
    this.categories = [];
    const response: any = await this.categoryService.getCategories();
    console.log(response);
    if (!response.error) {
      if (response.length > 0) {
        this.categories = response;
        if (this.data[0] == "Edit") {
          var target = this.categories.find((temp) => temp.pkCatid == this.data[1]["fkCatid"]);
          console.log(target);
          this.selectedCategory = target;
        }
      } else {
        this.warningToast("No categories available");
      }
    } else {
      this.errorToast();
    }
  }

  async saveCategory() {
    await this.subCategoryService
      .saveSubCategoryV1(
        this.selectedCategory.pkCatid,
        this.subCatId,
        this.subCatNameEng,
        this.subCatNameMar,
        this.flag
      )
      .subscribe((response: any) => {
        console.log(response);
        if (!response.error) {
          if (response.toLowerCase() == "success") {
            this.successToast();
          } else {
            this.warningToast(response);
          }
        } else {
          this.errorToast();
        }
      });
  }

  async successToast() {
    await this._snackBar.open("Sub category details saved successfully.", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
    });
    this.dialogRef.close("success");
  }

  async warningToast(response: any) {
    await this._snackBar.open(response, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "warning-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast() {
    await this._snackBar.open("Oops, something went wrong, please try after sometime.", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: 3 * 1000,
    });
  }
}
